<h1>CIFRIS24 - Second National Conference</h1>
<div class="toptext">
	<p>
		CIFRIS24 is an international event, supported and organized by De Cifris, aimed at bringing together
		researchers in the field of cryptography, practitioners, developers, and users to foster cooperation and
		exchange techniques, tools, experiences, and ideas.
	</p>
	<p>
		The first morning is reserved to institutional and industrial stakeholders operating in the field of
		cryptography and cyber security. The first afternoon and the whole second day constitute the Scientific
		Session of the event, where scientific talks take place. The third day hosts eight related workshops.
	</p>
	<p>
		Scientific talks consist of a selection of:
	</p>
	<ul>
		<li> Invited talks and </li>
		<li> Contributed talks selected from the submitted papers by the Chairs and the Programme Committee. </li>
	</ul>
</div>
<!-------------------------------------------------------------------->
<app-main-conference24></app-main-conference24>
<app-workshops24></app-workshops24>
<h2> INVITED SPEAKERS </h2>
<div class="text">
	<ul>
		<li>
			<b>Claude Carlet</b> (Paris VIII - France)
		</li>
		<li>
			<b>Gregor Leander</b> (Ruhr-University Bochum - Germany)
		</li>
		<li>
			<b>Simona Samardjiska</b> (Radboud University - Netherlands)
		</li>
		<li>
			<b>Daniele Venturi</b> (University of Roma La Sapienza - Italy)
		</li>
	</ul>
</div>

<app-proceedings-button24></app-proceedings-button24>

<!-------------------------------------------------------------------->

<h2> ORGANIZATION </h2>
<div class="text">
	<h3> Institution </h3>
	<p>
		The “De Componendis Cifris Associazione di Promozione Sociale” (<a href="./">De Cifris</a>) is a non-profit
		scientific
		organization whose purpose is to spread cryptography in all its aspects, from theoretical foundations,
		applications to historical evolution and impact on society, and to facilitate the aggregation of scholars
		and researchers, so that from their collaboration project ideas and initiatives of scientific interest can
		rise.
	</p>

	<h3> Organizing Committee </h3>
	<ul>
		<li>
			Giulia Cavicchioni (University of Trento - Italy)
		</li>
		<li>
			Massimiliano Sala (University of Trento - Italy)
		</li>
		<li>
			Marco Pedicini (University of Roma Tre - Italy)
		</li>
	</ul>
	<h3> Chairs of the Scientific Session </h3>
	<ul>
		<li>
			Luca De Feo (IBM Research Europe - Switzerland)
		</li>
		<li>
			Barbara Masucci (University of Salerno - Italy)
		</li>
	</ul>
</div>